<template>
	<div>
		<CRow class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							Usuarios del Sistema
						</h3>
					</CCardHeader>
					<CCardBody>
						<!-- filtro de la tabla -->
						<CRow>
							<CCol sm="4">
								<CInput
									v-model="filter"
									placeholder="Búscar"
									label="Filtrar"
								></CInput>
							</CCol>
							<CCol sm="4">
								<div role="group" class="form-group">
									<label for="urb"
										>Registros por Página</label
									>
									<multiselect
										v-model="perPage"
										:options="recordsPergPage"
										:searchable="false"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
									</multiselect>
								</div>
							</CCol>
							<!-- <CCol sm="4">
                                <p>
                                    <span class="float-right">Cantidad de Usuarios: <CBadge shape="pill" color="info">
                                            {{totalRows}}</CBadge>
                                    </span>
                                </p>
                            </CCol> -->
						</CRow>
						<!-- tabla de los usuarios -->
						<CRow>
							<CCol sm="12">
								<p style="margin-bottom: 30px;">
									<span class="float-right"
										>Cantidad de Usuarios:
										<CBadge shape="pill" color="info">
											{{ totalRows }}</CBadge
										>
									</span>
								</p>
								<b-table
									@filtered="onFiltered"
									:filter="filter"
									v-if="showTable"
									stacked="lg"
									striped
									outlined
									hover
									bordered
									:current-page="currentPage"
									:per-page="perPage"
									:items="tableAllUsers"
									:fields="fieldsTableUsers"
								>
									<template #cell(index)="row">
										{{ row.index + 1 }}
									</template>
									<template #cell(verified)="row">
										<CBadge
											v-if="row.item.verified == 1"
											color="success"
											class="float-left"
										>
											Verificado</CBadge
										>
										<CBadge
											v-else
											color="warning"
											class="float-left"
											>No verificado</CBadge
										>
									</template>
									<template #cell(dateCreated)="row">
										{{ getHumanDate(row.item.dateCreated) }}
									</template>
									<template #cell(dateUpdated)="row">
										{{ getHumanDate(row.item.dateUpdated) }}
									</template>
									<template #cell(actions)="row">
										<!-- <b-button title="Reenviar Correo" id="resendMail" pill variant="info" size="sm"
                                            class="mr-1">
                                            <i class="fas fa-paper-plane"></i>
                                        </b-button> -->
										<b-button
											@click="
												goToEditUser(row.item.idUsers)
											"
											title="Editar Usuario"
											id="editUser"
											pill
											variant="primary"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-user-edit"></i>
										</b-button>
										<b-button
											@click="modalDelete(row)"
											title="Eliminar Usuario"
											id="deleteUser"
											pill
											variant="danger"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-trash-alt"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<!-- paginacion de la tabla -->
						<CRow>
							<CCol sm="12">
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									align="right"
									first-number
									last-number
									pills
								>
									<template #prev-text
										><span class="text-primary"
											>Anterior</span
										></template
									>
									<template #next-text
										><span class="text-success"
											>Siguiente</span
										></template
									>
									<template #page="{ page, active }">
										<b v-if="active">{{ page }}</b>
										<i v-else>{{ page }}</i>
									</template>
								</b-pagination>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
			<!-- modal para confirmar que se desea eliminar el usuario -->
			<CModal
				:show.sync="modalConfirmDelete"
				:close-on-backdrop="false"
				:centered="true"
				title="Eliminar usuario"
				size="lg"
				color="danger"
				style="text-align:justify;"
			>
				<CRow>
					<CCol>
						<span>
							<p>
								Estas intentado eliminar el siguiente usuario:
							</p>
							<p>
								Nombre: <b>{{ userForDelete.name }}</b>
							</p>
							<p>
								Perfil: <b>{{ userForDelete.profile }}</b>
							</p>
							<p>
								Id en el SCC: <b>{{ userForDelete.idUser }}</b>
							</p>
						</span>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<span>
							<p>
								Si eliminas este usuario ya
								<b>no podrá acceder</b> al sistema
								<b>Mail Update</b>
							</p>
						</span>
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<span>
							<p>
								Si deseas realmente eliminar el usuaio por favor
								escribe <b>Eliminar</b> y luego haz clic en el
								botón <b>Eliminar el usuario</b>
							</p>
						</span>
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="4">
						<CInput v-model="confirmDelete"></CInput>
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<span>
							<p>
								<b-badge variant="info">Nota:</b-badge> esta
								acción solo eliminara el usuario de
								<b>Mail Update</b> no del
								<b>SCC</b>
							</p>
						</span>
					</CCol>
				</CRow>
				<template #header>
					<h6 class="modal-title">Eliminar Usuario</h6>
					<CButtonClose
						@click="modalConfirmDelete = false"
						class="text-white"
					/>
				</template>
				<template #footer>
					<b-button
						v-if="confirmDelete === 'Eliminar'"
						@click="deleteUser(userForDelete.idUser)"
						pill
						variant="warning"
						size="lg"
						class="mr-1"
					>
						Eliminar el usuario
					</b-button>
					<!-- <b-button v-else disabled pill variant="warning" size="lg" class="mr-1">Eliminar el usuario
                    </b-button> -->
					<b-button
						@click="modalConfirmDelete = false"
						pill
						variant="primary"
						size="lg"
						class="mr-1"
						>No eliminar
					</b-button>
				</template>
			</CModal>
			<!-- modal de confirmacion al eliminar exitosamente un usuario -->
			<CModal
				:show.sync="modalSuccessDelete"
				:close-on-backdrop="false"
				:centered="true"
				title="Se elimino el usuario!!"
				size="lg"
				color="success"
				style="text-align:justify;"
			>
				<CRow>
					<CCol>
						<span
							>Has eliminado con éxito el usuario para
							<b>{{ userForDelete.name }}</b></span
						>
					</CCol>
				</CRow>
				<br />
				<CRow>
					<CCol>
						<span>
							Recuerda que ya <b>no podrá acceder</b> al sistema
							<b>Mail Update</b>.
						</span>
					</CCol>
				</CRow>
				<template #header>
					<h6 class="modal-title">Se elimino el usuario!!</h6>
					<CButtonClose
						@click="modalSuccessDelete = false"
						class="text-white"
					/>
				</template>
				<template #footer>
					<b-button
						@click="modalSuccessDelete = false"
						pill
						variant="success"
						size="lg"
						class="mr-1"
						>Cerrar
					</b-button>
				</template>
			</CModal>
		</CRow>
	</div>
</template>
<script>
	//este componente muestra una tabla con todos los usuarios registrados en el sistema
	import adminUsers from '../../functions/functionsAdminUsers';
	export default {
		/**Componente del modulo usuarios usado para la consulta de los usuarios existentes
		 * en el sistema y acceder a la opción de editar un usuario */
		name: 'AllUsers',
		title: 'Consultar Usuarios | Infoguia',
		data() {
			return {
				tableAllUsers: [],
				fieldsTableUsers: [
					{
						key: 'index',
						label: 'Nº',
					},
					{
						key: 'name',
						label: 'Nombre',
					},
					{
						key: 'abbreviationSCC',
						label: 'Abreviatura',
					},
					{
						key: 'email',
						label: 'E-Mail',
					},
					{
						key: 'dateCreated',
						label: 'Fecha de Creación',
					},
					{
						key: 'dateUpdated',
						label: 'Fecha de Edición',
					},
					{
						key: 'profile',
						label: 'Perfil',
					},
					{
						key: 'verified',
						label: 'Verificado',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				showTable: false,
				filter: '',
				recordsPergPage: [5, 10, 15],
				modalConfirmDelete: false,
				modalSuccessDelete: false,
				userForDelete: {},
				confirmDelete: '',
			};
		},
		created() {
			let loader = this.$loading.show();
			adminUsers
				.getAllUsers()
				.then((response) => {
					//console.log(response)
					this.totalRows = response.length;
					for (let index = 0; index < response.length; index++) {
						this.tableAllUsers[index] = {
							name: response[index].name,
							abbreviationSCC:
								response[index].abbreviationSCC != ''
									? response[index].abbreviationSCC
									: 'S/I',
							email: response[index].email,
							dateCreated: response[index].created_at,
							dateUpdated: response[index].updated_at,
							profile: response[index].profile.name,
							verified: response[index].verified,
							idUsers: response[index].idUsers,
						};
					}
					if (this.tableAllUsers.length > 0) {
						this.showTable = true;
					}
				})
				.catch((error) => {
					console.log(error)
					//this.$router.go()
					// let errorCode = error.response.status;
					// switch (errorCode) {
					// 	case 401:
					// 		sessionStorage.removeItem('accessToken');
					// 		sessionStorage.removeItem('userInfo');
					// 		this.$router.push({
					// 			name: 'Login',
					// 		});
					// 		break;
					// }
				})
				.finally(() => {
					loader.hide();
				});
		},
		methods: {
			getHumanDate: function(date) {
				// Metodo para formatear la fecha devuelta por la API en el Request
				if (date === null || date === '') {
					return 'S/I';
				} else {
					//return moment(date, 'DD-MM-YYYY h:mm:ss a').format('L LTS');
					return this.$moment(date, 'DD-MM-YYYY h:mm:ss a').format(
						'L'
					);
				}
			},
			onFiltered(filteredItems) {
				// Metodo para actualizar el numero de paginas en el paginado a medida que se filtra
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			modalDelete(rowTodelete) {
				// Metodo para mostrar la modal de confirmacion antes de eliminar
				this.confirmDelete = '';
				this.userForDelete = {
					name: rowTodelete.item.name,
					idUser: rowTodelete.item.idUsers,
					profile: rowTodelete.item.profile,
				};
				this.modalConfirmDelete = true;
			},
			deleteUser(idUser) {
				//Metodo para eliminar el usuario una vez confirmado mediante la modal
				let loader = this.$loading.show();
				adminUsers
					.deleteUser(idUser)
					.then((response) => {
						//console.log(response)
						this.tableAllUsers.splice(
							this.tableAllUsers.findIndex(
								(item) => item.idUsers === idUser
							),
							1
						);
						this.modalConfirmDelete = false;
						this.modalSuccessDelete = true;
					})
					.catch((error) => {
						//console.log(error)
						let errorCode = error.response.status;
						switch (errorCode) {
							case 401:
								sessionStorage.removeItem('accessToken');
								sessionStorage.removeItem('userInfo');
								this.$router.push({
									name: 'Login',
								});
								break;
						}
					})
					.finally(() => {
						loader.hide();
					});
			},
			goToEditUser(idUser) {
				//Metodo que llama al componente para editar el usuario
				this.$router.push('/user/editUser/' + idUser);
			},
		},
	};
</script>
